import {
  STEPS,
  selectScheduleTourStep,
  setScheduleTourShowModal,
  setScheduleTourStep
} from '../../../../../../store/slices/scheduleTour'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from '../../../../..'
import ScheduleTourModalSteps from './Steps/ScheduleTourModalSteps'
import { Listing } from '../../../../../../api/gqlaxy/gql/generated/graphql'

import styles from './ScheduleTourModal.module.scss'

export interface ScheduleTourModalProps {
  listing: Listing
}

export const ScheduleTourModal = ({ listing }: ScheduleTourModalProps) => {
  const dispatch = useDispatch()
  const currentStep = useSelector(selectScheduleTourStep)

  const handleModalClose = () => {
    dispatch(setScheduleTourStep(STEPS[0]))
    dispatch(setScheduleTourShowModal(false))
  }

  return (
    <Modal
      toggle={handleModalClose}
      progress={((STEPS.indexOf(currentStep) + 1) / STEPS.length) * 100}
      progressColor='var(--brand-secondary-400)'
      className={styles.modal}
      overrideContent
      scrollOnWrapper
      resetScroll
      open
    >
      <ScheduleTourModalSteps listing={listing} />
    </Modal>
  )
}
